import script from "./CustomDropdown.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomDropdown.vue?vue&type=script&setup=true&lang=js"

import "./CustomDropdown.vue?vue&type=style&index=0&id=94a114ba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-94a114ba"]])

export default __exports__